export default function AdminAnalyticsTab({ analyticsData }) {
  return (
    <div>
      <h2 className="text-xl font-medium text-[#2D2A26] mb-6">Prompt Category Analytics</h2>
      
      {/* Summary Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl p-5 border border-[#E8E4DE]">
          <p className="text-sm text-[#6E6A66] mb-1">Total Prompt Responses</p>
          <p className="text-3xl font-light text-[#2D2A26]">{analyticsData?.total_responses || 0}</p>
        </div>
        <div className="bg-white rounded-xl p-5 border border-[#E8E4DE]">
          <p className="text-sm text-[#6E6A66] mb-1">Categories Tracked</p>
          <p className="text-3xl font-light text-[#A87C6D]">{analyticsData?.by_category?.length || 0}</p>
        </div>
        <div className="bg-white rounded-xl p-5 border border-[#E8E4DE]">
          <p className="text-sm text-[#6E6A66] mb-1">Top Prompts</p>
          <p className="text-3xl font-light text-[#2D2A26]">{analyticsData?.top_prompts?.length || 0}</p>
        </div>
      </div>

      {/* Category Breakdown */}
      <div className="bg-white rounded-xl border border-[#E8E4DE] p-6 mb-8">
        <h3 className="text-lg font-medium text-[#2D2A26] mb-4">Responses by Category</h3>
        {analyticsData?.by_category?.length > 0 ? (
          <div className="space-y-4">
            {analyticsData.by_category.map(cat => {
              const catInfo = analyticsData.category_info?.[cat.category] || {};
              const percentage = analyticsData.total_responses > 0 
                ? Math.round((cat.response_count / analyticsData.total_responses) * 100) 
                : 0;
              return (
                <div key={cat.category}>
                  <div className="flex justify-between items-center mb-1">
                    <span className="text-sm font-medium text-[#2D2A26]">
                      {catInfo.name || cat.category}
                    </span>
                    <span className="text-sm text-[#6E6A66]">
                      {cat.response_count} ({percentage}%)
                    </span>
                  </div>
                  <div className="h-3 bg-[#E8E4DE] rounded-full overflow-hidden">
                    <div 
                      className="h-full rounded-full transition-all duration-500"
                      style={{ 
                        width: `${percentage}%`,
                        backgroundColor: catInfo.color || '#A87C6D'
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-[#6E6A66] text-center py-8">No data yet. Analytics will appear as users respond to prompts.</p>
        )}
      </div>

      {/* Top Prompts */}
      <div className="bg-white rounded-xl border border-[#E8E4DE] p-6">
        <h3 className="text-lg font-medium text-[#2D2A26] mb-4">Most Responded Prompts</h3>
        {analyticsData?.top_prompts?.length > 0 ? (
          <div className="space-y-3">
            {analyticsData.top_prompts.slice(0, 10).map((prompt, idx) => {
              const catInfo = analyticsData.category_info?.[prompt.category] || {};
              return (
                <div 
                  key={prompt.prompt_id} 
                  className="flex items-start gap-4 p-3 rounded-lg hover:bg-[#FDFBF7]"
                >
                  <span className="text-lg font-medium text-[#A8A4A0] w-6">{idx + 1}</span>
                  <div className="flex-1">
                    <p className="text-[#2D2A26] mb-1">&ldquo;{prompt.text}&rdquo;</p>
                    <div className="flex items-center gap-2">
                      <span 
                        className="text-xs px-2 py-0.5 rounded-full"
                        style={{ 
                          backgroundColor: `${catInfo.color || '#A87C6D'}20`,
                          color: catInfo.color || '#A87C6D'
                        }}
                      >
                        {catInfo.name || prompt.category}
                      </span>
                      <span className="text-xs text-[#A8A4A0]">
                        {prompt.response_count} responses
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-[#6E6A66] text-center py-8">No prompt data yet.</p>
        )}
      </div>
    </div>
  );
}
